import { useMutation, useQueryClient } from '@tanstack/react-query';
import balancesApi from '@/features/dashboard/balances/api/balancesApi.ts';
import { toast } from 'sonner';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';

export default function useRecalculateClientBalance(clientId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => balancesApi.recalculateClientBalance(clientId),
    onSuccess: () => {
      invalidateFinanceRelatedQueries(queryClient);
      toast.success('Saldo zostało przeliczone');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas przeliczania salda.',
      });
    },
  });
}
